import React from "react";
import { useDispatch } from "react-redux";
import { updateBonus } from "../../redux/bonusSlice";

const ApprovalBonusModal = ({ isOpen, onClose, bonus }) => {
  const dispatch = useDispatch();

  const handleApprove = async () => {
    try {
      await dispatch(updateBonus({ id: bonus.id, updatedData: { status: "Approved" } })).unwrap();
      onClose();
    } catch (err) {
      console.error("Failed to approve bonus:", err);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-sm p-4">
        <h2 className="text-lg font-medium mb-4">
          Are you sure you want to approve the bonus for {bonus.employeeName}?
        </h2>
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
          >
            No
          </button>
          <button
            onClick={handleApprove}
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalBonusModal;